export class EntraRestoreReportSummaryByMethod {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveredFromRecycleBin",
            "baseName": "recoveredFromRecycleBin",
            "type": "number",
            "format": ""
        },
        {
            "name": "recreated",
            "baseName": "recreated",
            "type": "number",
            "format": ""
        },
        {
            "name": "patched",
            "baseName": "patched",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportSummaryByMethod.attributeTypeMap;
    }
    constructor() {
    }
}
